import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../components/mweb/Icon/Icon';
import history from 'hb-redux-store/history';
import { RUPEE_SYMBOL } from 'hb-redux-store/util/constantServices';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';

const DummyElement = ({ height }) => <div style={{ height }} />;

const PaymentHeader = props => {
  const { summary, onCheckChange, onShowSummary, source = 'PAYMENT' } = props;
  const selected = summary?.isPartialPayment;
  const walletBalance = summary?.billingDetails?.hbWalletAmount;
  const headerRef = React.useRef();
  const dummyHeaderRef = React.useRef();
  const scrollFunction = () => {
    const header = headerRef.current;
    const dummyHeader = dummyHeaderRef.current;
    const sticky = header?.offsetTop;
    const OFFSET_TOP = 0;
    if (header && dummyHeader)
      if (sticky - OFFSET_TOP < window.pageYOffset) {
        header.classList.add('hidden');
        dummyHeader.classList.add('sticky-top');
      } else {
        header.classList.remove('hidden');
        dummyHeader.classList.remove('sticky-top');
      }
  };
  const getCheckboxUnit = (ref, isDummy) => (
    <div
      ref={ref}
      className={`use-hb-wallet--checkbox ${
        isDummy ? 'dummy' : ''
      } flex-align-items-center justify-content--space-between`}
      onClick={() => onCheckChange({ isPartialPayment: !selected })}
    >
      <div>
        <Icon class="icon-payment-wallet-white-bg" size={24} />
        <span>Use VXL Money</span>
      </div>
      <div>
        <span className="bold">
          {RUPEE_SYMBOL}
          {summary?.billingDetails?.payableWalletAmount}
        </span>
        <Icon
          class={`icon-common-white-bg-checkbox-${
            selected ? 'selected' : 'unselected'
          }`}
          size={20}
        />
      </div>
    </div>
  );
  React.useEffect(() => {
    window.addEventListener('scroll', scrollFunction);
    return () => {
      window.removeEventListener('scroll', scrollFunction);
    };
  }, []);
  if (source === 'RECHARGE_FORM') {
    return (
      <React.Fragment>
        <div className="use-hb-wallet">
          <div className="use-hb-wallet--nav flex-align-items-center">
            <Icon
              class="icon-back-bar-back-white"
              size={24}
              onClick={history.goBack}
            />
            <div>Select Payment Method</div>
          </div>
          <div className="use-hb-wallet--recharge">
            Add remaining ₹{summary?.minrc} to VXL Money for faster checkout
          </div>
          <div className="use-hb-wallet--summary-link flex-align-items-center">
            <span onClick={onShowSummary}>Transaction Summary</span>
            <Icon
              class="icon-common-white-arrow-right"
              size={9}
              onClick={onShowSummary}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
  if (source === 'RECHARGE_PAYMENT') {
    return (
      <React.Fragment>
        <div className="use-hb-wallet fixed-header">
          <div className="use-hb-wallet--nav flex-align-items-center">
            <Icon
              class="icon-back-bar-back-white"
              size={24}
              onClick={history.goBack}
            />
          </div>
          <div className="use-hb-wallet--recharge-payment flex-align-items-center">
            <div className="hb-icon">
              <Icon class="icon-payment-wallet-white-bg" size={22} />
            </div>
            {summary?.rechargeAmount && (
              <span>Add ₹{summary?.rechargeAmount} to VXL Money</span>
            )}
          </div>
        </div>
        <DummyElement height={92} />
      </React.Fragment>
    );
  }

  if (source === 'PAYMENT') {
    if (!walletBalance) {
      return (
        <React.Fragment>
          <SecondaryNav
            showSearch={false}
            showCart={false}
            title="Select Payment Methods"
            capitalize
          />
          <div className="payments--summary">
            <div className="payments--summary--total-items">
              {`${summary?.billingDetails?.totalItems} ${
                summary?.billingDetails?.totalItems > 1 ? 'items' : 'item'
              }`}
            </div>
            <div className="payments--summary--payable justify-content--space-between">
              <div>Payable Amount</div>
              <div>
                &#8377;
                {summary?.billingDetails?.payableAmount}
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="use-hb-wallet">
          <div className="use-hb-wallet--nav flex-align-items-center">
            <Icon
              class="icon-back-bar-back-white"
              size={24}
              onClick={history.goBack}
            />
            <div>Select Payment Method</div>
          </div>
          {getCheckboxUnit(headerRef)}
          <div className="use-hb-wallet--summary-link flex-align-items-center">
            <span onClick={onShowSummary}>Transaction Summary</span>
            <Icon
              class="icon-common-white-arrow-right"
              size={9}
              onClick={onShowSummary}
            />
          </div>
          {getCheckboxUnit(dummyHeaderRef, true)}
        </div>
      </React.Fragment>
    );
  }
  return false;
};

PaymentHeader.propTypes = {
  onCheckChange: PropTypes.func,
  summary: PropTypes.object,
  onShowSummary: PropTypes.func,
  source: PropTypes.oneOf(['RECHARGE_FORM', 'RECHARGE_PAYMENT', 'PAYMENT']),
};

export default PaymentHeader;
